import React, { memo } from 'react';
import { Table, Column } from 'react-virtualized';
import classNames from 'classnames';
import styles from './OrderTable.module.scss';

const OrderTableHead = memo(({ t, baseCurrency, quoteCurrency, width }) => {
  return (
    <Table height={25} width={width} headerHeight={25} rowCount={0} rowHeight={25} rowGetter={() => {}}>
      <Column
        label={`${t('exchange.price')} (${quoteCurrency})`}
        flexGrow={1}
        dataKey="price"
        width={100}
        className="alignRight"
        headerClassName={styles.orderBookTableHeader}
        style={{ marginLeft: 0 }}
      />
      <Column
        // label={`${t('exchange.size')}(${baseCurrency})`}
        label={`Кол-во (${baseCurrency})`}
        flexGrow={1}
        dataKey="volume"
        width={100}
        className="alignRight"
        headerClassName={classNames(styles.orderBookTableHeader, styles.orderBookTableHeader_right)}
      />
      <Column
        // label={`${t('exchange.total')}`}
        label={`Итого (${quoteCurrency})`}
        dataKey="total"
        width={100}
        flexGrow={1}
        className={styles.orderBookTableColumn}
        headerClassName={classNames(styles.orderBookTableHeader, styles.orderBookTableHeader_right)}
        style={{ margin: '0 0 0 4px' }}
      />
    </Table>
  );
});

export default OrderTableHead;
